import axios from "axios";
import { del, get, post, patch,  put } from "./fee_types_api_helper";
import * as url from "./fee_types_url_helper";





// Get features
export const getFeeTypes = () => get(url.GET_FEE_TYPES);


// Add feature
export const addNewFeeType = (feeType) => post(url.ADD_NEW_FEE_TYPE, feeType);
//export const addNewBranch = branch => post(url.ADD_NEW_FEE_TYPE, JSON.stringify(branch));




// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateFeeType = (feeType) => patch(`${url.UPDATE_FEE_TYPE}/${feeType.id}`,  feeType);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteFeeType = (feeType) => del(`${url.DELETE_FEE_TYPE}/${feeType.id}`);







export {
  //getLoggedInUser,
  
  
};
